import React, { useState, useEffect, useContext } from 'react';
import { MainSettingsContext } from '../App.js';
import { getWebClient } from '../helpers/Helpers.js';
import Spinner from './components/Spinner';
import Navbutton from './components/Navbutton.js';
import PromptError from './components/PromptError';
import 'font-awesome/css/font-awesome.min.css';
import Rating from 'react-rating';

const client = getWebClient();

export default function Ratings() {

    const { locationAndDates } = useContext(MainSettingsContext);

    const [viewMode, setViewMode] = useState('waiting');

    const [partnersToRate, setPartnersToRate] = useState(null);

    useEffect(() => {

        client.get(`/api/getpartnerstorate`)
            .then(function (response) {
                setPartnersToRate(response.data);
                setViewMode('');
                window.scrollTo(0, 0);
            })

    }, []);

    function handleSetRating(partnerId, value) {

        client.post('/api/setpartnerRating',
            {
                partnerId: partnerId,
                stars: value,
            })
            .then(function (response) {
                setViewMode('');
            })
            .catch(function (error) {
                console.log(error);
                setViewMode('error');
            });

    }

    let partnersList = [];

    if (partnersToRate) {
        partnersList = partnersToRate.map((partner, index) => {
            return (
                <div key={index}>
                    <div className="rating-partnername">{partner.ragioneSociale}</div>
                    <div className="rating-datetime">{partner.dataOra}</div>
                    <Rating
                        initialRating={partner.stelle}
                        emptySymbol="fa fa-star-o fa-2x rating-star"
                        fullSymbol="fa fa-star fa-2x rating-star"
                        onChange={(value) => handleSetRating(partner.id, value)}
                    />
                    <hr></hr>
                </div>
                
            )
        });
    }

    return (

        <>

            <section className="main-sec">
                <header className="header">
                    <div className="row align-items-center">
                        <div className="col-md-6">
                            <img src="assets/images/logo.svg" alt="" />
                        </div>
                        <div className="col-md-6">
                            <h2>Workshop Agenda</h2>
                            <p>{locationAndDates}</p>
                        </div>
                    </div>
                </header>

                <div className="buyer-container search-container">
                    <h1 className="main-heading">Rate your partners</h1>
                    <p>Here you can rate your partners based on your experience with them.</p>                
                    <center>
                        <hr></hr>
                        {partnersList}
                    </center>
                </div>
                <footer className="footer">
                    <ul>
                        <li>&copy; {new Date().getFullYear()} - PromAx Communication SA - <a target="_blank" rel="noreferrer" href='http://www.sihe.ch'>www.sihe.ch</a><br></br>Tel. 0041/91/6118070 - <a href="mailto:segreteria@sihe.ch">segreteria@sihe.ch </a></li>
                    </ul>
                </footer>
            </section>

            <Navbutton></Navbutton>

            <Spinner show={viewMode === 'waiting'}></Spinner>
            <PromptError show={viewMode === 'error'} setViewMode={setViewMode}></PromptError>

        </>
    );

}